import { Component, OnInit, HostListener } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "../../Services/crud.service";
import { LogedInUserService } from "../../Services/loged-in-user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { NgbAccordionConfig, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { DeactiveConfirmComponent } from "../deactive-confirm/deactive-confirm.component";
import { CanComponentDeactivate } from "src/app/guards/can-deactivate.guard";
import { DeleteConfirmationDialogComponent } from "../delete-confirmation-dialog/delete-confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { FormStateService } from "src/app/Services/form.service";
import { LoadingService } from "src/app/Services/loading.service";
import { Clipboard } from "@angular/cdk/clipboard";

@Component({
  selector: "app-project-detail",
  templateUrl: "./project-detail.component.html",
  providers: [NgbAccordionConfig],
  styles: [
    `
      .border-error .form-control {
        border-color: red;

        .btn-success,
        .bg-success {
          background-color: #009262 !important;
          box-shadow: 0 0.125rem 0.625rem #73a83966 !important,
            0 0.0625rem 0.125rem #73a83980 !imortant;
        }
      }

      .example-h2 {
        margin: 10px;
      }

      .example-section {
        display: flex;
        align-content: center;
        align-items: center;
        height: 60px;
      }

      .example-margin {
        margin: 10px;
      }

      ::ng-deep .mat-slide-toggle-thumb {
        border-radius: 50%;
        background-color: #ccc; // neutral gray when off
        box-shadow: none;
        border: none;
      }

      ::ng-deep button .mdc-switch {
        width: 80% !important;
      }

      ::ng-deep .mdc-switch--unselected .mdc-switch__track::before {
        background-color: #ffcccc !important;
      }

      ::ng-deep .mdc-switch--unselected:hover .mdc-switch__track::before {
        background-color: #ffcccc;  !important;
      }

      ::ng-deep .custom-swal-close{
      background-color : transparent !important;
      border : none !important;
      }
  `,
  ],
  standalone: false,
})
export class ProjectDetailComponent implements OnInit, CanComponentDeactivate {
  currentProject;
  languageList = [];
  projectEnable = true;
  isAddProject = true;
  isLoading = false;
  form: UntypedFormGroup;
  submitted = false;
  isWorking = false;
  keyInfo: any = {};
  isRegenrate = false;
  urlMatchingError = false;
  matchingField: string[] = [];
  state = true;
  primaryLanguage: any = "61321bc60bd2d119488f9329";
  supportedLanguages: [];
  selectedSupportedLanguages: [];

  showForm = false;
  data: [];
  projectManagementId: any;

  config = {
    displayKey: "name", // if objects array passed which key to be displayed defaults to description
    search: true,
    limitTo: 3,
  };

  DEAULT_ERROR_MESSAGE = {
    NAME: "Name is require.",
    LIVE_URL: "Live URL is require.",
    TEST_URL: "Test URL is require.",
    DEV_URL: "Dev URL is require.",
  };
  loadingSub;
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private dialog: MatDialog,
    private formStateService: FormStateService,
    private loadingService: LoadingService,
    private clipBoard: Clipboard
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.loadingService.show();
    this.route.params.subscribe((params) => {
      let projectId = params["id"];
      this.isAddProject = projectId === "new-project";

      if (this.isAddProject) {
        this.currentProject = { name: "New Project" };
        this.isLoading = false;
      }

      if (!this.isAddProject) {
        this.getProjectManagementData =
          this.getProjectManagementData.bind(this);
        this.getServerURL = this.getServerURL.bind(this);
        this.getProjectManagementData(projectId);

        this.loadingService.hide();
      }
    });
    this.getLanguages();

    this.form = this.formBuilder.group({
      name: ["", [Validators.required, this.noOnlySpaces()]],
      liveUrl: ["", [Validators.required, this.uniqueUrlValidator("liveUrl")]],
      testUrl: ["", [Validators.required, this.uniqueUrlValidator("testUrl")]],
      devUrl: ["", [this.uniqueUrlValidator("devUrl")]],
      description: [""],
      status: [""],
    });

    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.isLoading = false;
    });
  }
  isValidUrl(urlString: string) {
    var urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // validate protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // validate fragment locator
    return !!urlPattern.test(urlString);
  }

  isUrlValidator(urlType: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;

      if (!formGroup) {
        return null;
      }

      const liveUrl = formGroup.get("liveUrl").value;
      const testUrl = formGroup.get("testUrl").value;
      const devUrl = formGroup.get("devUrl").value;

      let isLiveUrl = true;
      let isTestUrl = true;
      let isDevUrl = true;

      if (urlType === "liveUrl") {
        isLiveUrl = this.isValidUrl(liveUrl);
      } else if (urlType === "testUrl") {
        isTestUrl = this.isValidUrl(testUrl);
      } else if (urlType === "devUrl" && devUrl) {
        isDevUrl = this.isValidUrl(devUrl);
      }

      if (!isLiveUrl || !isTestUrl || !isDevUrl) {
        return { isUrl: true };
      }

      return null;
    };
  }

  uniqueUrlValidator(urlType: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;

      if (!formGroup) {
        return null;
      }

      const liveUrl = formGroup.get("liveUrl").value;
      const testUrl = formGroup.get("testUrl").value;
      const devUrl = formGroup.get("devUrl").value;

      let isLiveUrlDuplicate = false;
      let isTestUrlDuplicate = false;
      let isDevUrlDuplicate = false;

      if (urlType === "liveUrl") {
        isLiveUrlDuplicate = testUrl === liveUrl || devUrl === liveUrl;
      } else if (urlType === "testUrl") {
        isTestUrlDuplicate = liveUrl === testUrl || devUrl === testUrl;
      } else if (urlType === "devUrl" && devUrl) {
        isDevUrlDuplicate = liveUrl === devUrl || testUrl === devUrl;
      }

      if (isLiveUrlDuplicate || isTestUrlDuplicate || isDevUrlDuplicate) {
        return { uniqueUrl: true };
      }

      return null;
    };
  }

  get liveUrlErrors() {
    const liveUrlControl = this.form.get("liveUrl");

    let liveUrlError = liveUrlControl.hasError("uniqueUrl")
      ? "Live URL is duplicate."
      : null;

    return liveUrlError || null;
  }

  get testUrlErrors() {
    const testUrlControl = this.form.get("testUrl");

    let testUrlError = testUrlControl.hasError("uniqueUrl")
      ? "Test URL is duplicate."
      : null;

    return testUrlError || null;
  }

  get devUrlErrors() {
    const devUrlControl = this.form.get("devUrl");

    let devUrlError = devUrlControl.hasError("uniqueUrl")
      ? "Dev URL is duplicate."
      : null;

    return devUrlError || null;
  }

  markFormDirty() {
    this.form.markAsDirty();
  }

  getProjectManagementData(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.currentProject = response;
        self.projectManagementId = self.currentProject.id;
        self.state = self.currentProject.status;
        self.primaryLanguage = self.currentProject.primaryLanguage;
        self.selectedSupportedLanguages = self.currentProject.supportedLanguage;

        self.form.patchValue(self.currentProject);
        self.form.markAsPristine();
        self.formStateService.clearFormDirty();
      },
      'projectManagements/findOne?filter={"where":{"id":"' + projectId + '"}}'
    );
  }

  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  toggleDisable() {
    if (this.form.disabled) {
      this.form.enable();
    } else {
      this.form.disable();
    }
  }

  onDropDownClose(items: any) {
    this.supportedLanguages = items;
  }

  onChange(event) {
    this.state = event.currentValue;
    this.markFormDirty();
  }

  onItemSelect(items: any) {
    this.supportedLanguages = items;
  }

  onSelectAll(items: any) {
    this.supportedLanguages = items;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  isUrlMatchingError(field: string) {
    console.log("field....", field);
  }

  onSubmit() {
    this.matchingField = [];
    var self = this;
    self.isWorking = true;
    self.submitted = true;

    // stop here if form is invalid
    if (self.form.invalid) return;

    // submit API call
    var payload = self.form.value;
    self.logedInUserService.get(function (logedInUser) {
      payload.companyId = logedInUser.companyId;
    });

    payload.status = self.state;
    payload.primaryLanguage = self.primaryLanguage;

    if (self.supportedLanguages || self.selectedSupportedLanguages)
      payload.supportedLanguage = self.supportedLanguages
        ? self.supportedLanguages
        : self.selectedSupportedLanguages;
    else {
      payload.supportedLanguage = [];
    }
    // Correct the URL
    payload.devUrl = self.getServerURL(payload.devUrl);
    payload.liveUrl = self.getServerURL(payload.liveUrl);
    payload.testUrl = self.getServerURL(payload.testUrl);

    this.urlMatchingError =
      payload.devUrl === payload.liveUrl ||
      payload.devUrl === payload.testUrl ||
      payload.liveUrl === payload.testUrl;

    if (this.urlMatchingError) {
      // Display error toaster
      // Determine the matching field
      if (payload.devUrl === payload.liveUrl) {
        this.matchingField.push("devUrl", "liveUrl");
      }
      if (payload.devUrl === payload.testUrl) {
        this.matchingField.push("devUrl", "testUrl");
      }
      if (payload.liveUrl === payload.testUrl) {
        this.matchingField.push("liveUrl", "testUrl");
      }

      this.toastr.error("Duplicate URLs", "Invalid operation");
    } else {
      if (self.projectManagementId) {
        payload.id = self.projectManagementId;
        self.crudService.update(
          payload,
          function (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              self.currentProject = response;
              self.form.patchValue(self.currentProject);
              self.toastr.success(
                "Project has been updated successfully.",
                "Success"
              );
              self.getProjectManagementData(self.projectManagementId);
              self.isWorking = false;
              self.submitted = false;
              self.form.markAsPristine();
              self.formStateService.clearFormDirty();
            }
          },
          "projectManagements"
        );
      } else {
        self.crudService.post(
          payload,
          function (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              self.toastr.success(
                "Project has been created successfully.",
                "Success"
              );
              self.isWorking = false;
              self.submitted = false;
              self.form.markAsPristine();
              self.formStateService.clearFormDirty();
              self.router.navigate(["/page/dashboard"]);
            }
          },
          "projectManagements"
        );
      }
    }
  }

  getServerURL(url) {
    if (url && url.endsWith("/")) {
      return url.substring(0, url.length - 1);
    } else {
      return url;
    }
  }

  onProjectReset() {
    this.submitted = false;
    this.state = true;
    this.primaryLanguage = "";
    this.selectedSupportedLanguages = [];
    this.form.reset();
    if (this.isAddProject) {
      this.toggleForm(null);
    } else {
      this.toggleForm(this.currentProject);
    }
  }

  toggleForm(projectManagement: any) {
    this.showForm = !this.showForm;
    if (projectManagement) {
      this.projectManagementId = projectManagement.id;
      this.state = projectManagement.status;
      this.primaryLanguage = projectManagement.primaryLanguage;
      this.selectedSupportedLanguages = projectManagement.supportedLanguage;

      this.form.patchValue(projectManagement);
    }
    setTimeout(() => {
      this.form.markAsPristine();
      this.formStateService.clearFormDirty();
    }, 1000);
  }

  openScreenDetailView() {
    this.router.navigate(["/page/project-detail", this.currentProject.id]);
  }

  findSecretKey() {
    var self = this;

    if (!this.projectManagementId) return;
    self.crudService.get(
      null,
      function (response) {
        if (response && response.generatedKeyTimeStamp) {
          self.crudService.get(
            null,
            function (response) {
              /* TODO: Look here if key pop-up is not opened */
              if (response && response.key) {
                self.generateSecretKey(response.key);
              } else if (
                response &&
                (response.key == null || response.key == undefined)
              ) {
                self.generateSecretKey(null);
              }
              self.keyInfo = response;
            },
            "projectAccessKeys/findOne?filter[order]=created DESC&filter[where][projectManagementId]=" +
              self.projectManagementId
          );
        } else {
          self.generateSecretKey(null);
        }
      },
      "projectManagements/" + this.projectManagementId
    );
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      width: "600px",
      panelClass: "custom-bg",
      data: {
        title: this.translateService.instant("Form.RegenerateSecretKey"),
        paragraph: [
          this.translateService.instant("Form.RegenerateSecretKeyMsg"),
          // this.translateService.instant("Form.RegenerateSecretKeyMsgConfirm"),
        ],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // console.log("result result result", result);
        if (result == true) {
          this.isRegenrate = true;
        }
        this.generateSecretKey(null);
      }
    });
  }

  generateSecretKey(secretKey) {
    var self = this;
    if (!this.projectManagementId) return;
    var payload = { projectManagementId: this.projectManagementId };

    if (!secretKey) {
      if (!this.isRegenrate) {
        this.crudService.post(
          payload,
          function (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              if (response.key) {
                self.openSecretKeyPopup(response.key);
              } else {
                self.toastr.error(
                  "Unable to create secret key. Please Try again!",
                  "Invalid Operation"
                );
              }
            }
          },
          "projectAccessKeys"
        );
      } else {
        this.crudService.update(
          payload,
          function (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              if (response.key) {
                self.openSecretKeyPopup(response.key);
              } else {
                self.toastr.error(
                  "Unable to create secret key. Please Try again!",
                  "Invalid Operation"
                );
              }
            }
          },
          "projectAccessKeys/" + this.keyInfo["id"]
        );
      }
    } else {
      this.isRegenrate = true;

      self.openSecretKeyPopup(secretKey);
    }
  }

  openSecretKeyPopup(secretKey) {
    const currentHash = window.location.hash.replace("#", "");
    window.location.hash = currentHash + "&secret-key=myKey";
    Swal.fire({
      title:
        '<div class="pull-left" style="text-align: left;">' +
        this.translateService.instant("Form.SECRET_KEY_BUTTON") +
        "</div>",
      html:
        '<div style="display: flex;">' +
        '  <span for="secretkey" style="text-align: left; color: black; font-weight: bold;">' +
        this.translateService.instant("Form.SECRET_KEY") +
        ":</span>" +
        "</div>" +
        '<div style="display: flex; text-align: left;">' +
        '  <label id="secretkey">' +
        secretKey +
        "</label>" +
        "</div>" +
        '<div class="mt-2 pt-3 d-flex justify-content-between" style="display: flex;">' +
        '<span for="sampleCode" style="text-align: left; color: black; font-weight: bold;">' +
        this.translateService.instant("Form.SampleCode") +
        ":</span>" +
        '<div class="mb-1"><i id="copy-icon" class="fa-regular fa-copy" style="font-size: 20px; cursor:pointer"></i> </div>' +
        "</div>" +
        '<div class="code" id="copy-secretkey" #copy-secretkey style=" text-align: left; height: 150px;">' +
        '<xmp> <script src="' +
        environment.appURL +
        "/assets/TAS/tas.js?secretKey=" +
        secretKey +
        '&projectVersion=[versionName]&d=[addTodayDateVariable]"></script>' +
        "</xmp>" +
        "<div> <p> <xmp> <!-- Font Awesome CDN -->  </xmp></p> </div>" +
        '<xmp><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"> </xmp> ' +
        "Note: <i>versionName</i> and <i>addTodayDateVariable</i> will be replaced. <i>addTodayDateVariable</i> is added to avoid caching issues" +
        "</div>" +
        "<div id='sample-code-above'></div>",

      showConfirmButton: false,

      showClass: {
        popup: "animated fadeInLeft faster",
      },
      showCloseButton: true,
      customClass: {
        popup: "custom-popup-class",
        closeButton: "custom-swal-close",
      },
      footer: `
        <button id="regenKeyButton" class="swal2-styled swal2-confirm btn btn-primary">
          ${this.translateService.instant("Form.REGENERATE_KEY_BUTTON")}
        </button>
    
      `,
      buttonsStyling: false,
      onOpen: () => {
        // ✅ Add ID to close buttonlet currentHash = window.location.hash.replace("#", "");

        const closeBtn = document.querySelector(".swal2-close");
        if (closeBtn) {
          closeBtn.setAttribute("id", "close-secretKey-popup");
        }

        const regenKeyButton = document.getElementById("regenKeyButton");
        regenKeyButton.addEventListener("click", () => {
          this.openConfirmationDialog();
        });

        const copyIcon = document.getElementById("copy-icon");
        const copySecretKey = document.getElementById("copy-secretkey");
        if (copyIcon && copySecretKey) {
          copyIcon.addEventListener("click", () => {
            // this.copyToClipBoard();
            if (copySecretKey) {
              const text = copySecretKey.textContent || "";
              navigator.clipboard.writeText(copySecretKey.innerText.trim());

              this.toastr.clear();
              this.toastr.success("Copied successfully!");
              // Swal.fire("Copied!", "", "success");
            }
          });
        }
      },
    });
  }

  @HostListener("window:beforeunload")
  canDeactivate() {
    if (this.form.dirty) {
      const modalRef = this.modalService.open(DeactiveConfirmComponent, {
        backdrop: "static",
        centered: true,
      });
      return modalRef.result;
    }
    return true;
  }

  noOnlySpaces(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;

      if (value == null) {
        console.log("Input is null — considered valid.");
        return null;
      }

      const isEmptyOrWhitespace =
        typeof value === "string" && value.trim().length === 0;

      if (isEmptyOrWhitespace) {
        console.log("Validation failed: input is empty or whitespace only.");
        return { whitespace: true };
      }

      return null; // valid
    };
  }
}
